import { Truck } from "lucide-react";

const WORDS = [
  "Siamo i migliori nel settore.",
  "Non accettiamo compromessi.",
  "La qualità non è negoziabile.",
];

export default function Manifesto() {
  return (
    <section
      data-testid="manifesto-section"
      className="relative py-24 lg:py-32 bg-white overflow-hidden border-y border-brand-line"
    >
      <div className="absolute inset-0 dot-grid opacity-[0.35] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-5xl mx-auto reveal">
          <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-bold text-brand-primary mb-6">
            <span className="w-8 h-px bg-brand-primary" />
            Manifesto
            <span className="w-8 h-px bg-brand-primary" />
          </div>

          <h2 className="font-display font-extrabold text-[36px] sm:text-[56px] lg:text-[88px] leading-[0.95] sm:leading-[0.92] tracking-tighter text-brand-ink text-balance">
            {WORDS.map((w, i) => (
              <span key={i} className={`block reveal reveal-delay-${i + 1}`}>
                {i === 0 ? (
                  <>
                    Siamo i <span className="text-brand-primary">migliori</span> nel settore.
                  </>
                ) : i === 1 ? (
                  <>Non accettiamo <em className="not-italic underline decoration-brand-muted decoration-4 underline-offset-8">compromessi</em>.</>
                ) : (
                  <>La qualità <span className="text-brand-secondary">non è negoziabile</span>.</>
                )}
              </span>
            ))}
          </h2>

          <p className="mt-10 text-lg lg:text-xl text-brand-body max-w-3xl mx-auto leading-relaxed reveal reveal-delay-4">
            Ogni squadra, ogni cassa, ogni viaggio porta lo stesso impegno: trattare le vostre cose come se fossero le nostre.
            È così da 18 anni. È così che continueremo a farlo.
          </p>
        </div>

        {/* Marquee truck strip — infinite scroll right→left */}
        <div className="mt-20 relative overflow-hidden border-y border-brand-line py-7">
          {/* Side fade masks */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-12 sm:w-24 bg-gradient-to-r from-white to-transparent z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-12 sm:w-24 bg-gradient-to-l from-white to-transparent z-10" />

          <div
            data-testid="manifesto-marquee"
            className="flex items-center gap-12 whitespace-nowrap w-max animate-marquee will-change-transform"
          >
            {Array.from({ length: 2 }).map((_, dup) => (
              <div key={dup} aria-hidden={dup > 0} className="flex items-center gap-12 shrink-0">
                {[
                  "PUNTUALITÀ",
                  "★",
                  "CURA MANIACALE",
                  "★",
                  "ASSICURAZIONE TOTALE",
                  "★",
                  "ZERO COMPROMESSI",
                  "★",
                  "ECCELLENZA SICILIANA",
                  "★",
                  "TRASPARENZA",
                  "★",
                ].map((w, i) => (
                  <span
                    key={`${dup}-${i}`}
                    className={`font-display font-extrabold text-3xl lg:text-5xl tracking-tight ${
                      w === "★" ? "text-brand-primary" : "text-brand-ink"
                    }`}
                  >
                    {w}
                  </span>
                ))}
              </div>
            ))}
          </div>

          {/* Independent truck driving across the strip */}
          <div className="absolute top-1/2 -translate-y-1/2 truck-anim pointer-events-none z-20">
            <Truck className="w-12 h-12 text-brand-primary drop-shadow" strokeWidth={2.2} />
          </div>
        </div>
      </div>
    </section>
  );
}
